import React from 'react';
import './index.css';
const Footer = () => {
    return (
      <div>
       
          <footer className="bg-burbel  py-2 ">
          <div className="container">
            <h3 className="text-white text-center">&copy; 2020 <span className="text-yellow">Mohamed</span> Samir</h3>
            </div>
          </footer>
       
       
      </div>
    )
  }
  


export default Footer;
